export enum AspectRatio {
    UNDEFINED = 'undefined',
    FIT = 'fit',
    FILL = 'fill'
}

export interface Image {
    id?: string,
    file: File | null,
    isLocal: boolean,
    url: string,
}